import { type ProductData } from "../models/ProductData";
import { type TreeTableNode } from "../common/components/TreeTable/TreeTable";

export interface FacetValue {
  code: string;
  name: string;
  count: number;
  selected: boolean;
}

/// Stuff for the CategoryFilter
export interface ProductGroup {
  name: string;
  treeNodeUid: string;
  fullFacetUid: string;
  children: ProductGroup[];
  description?: string;
  order: number;
}

export interface TabularColumnConfig {
  name: string;
  hoverTitle: string;
  techValueUID: string;
  sortAsc?: string;
  sortDesc?: string;
  unit?: string;
}

export enum SearchDisplayMode {
  LIST = "1",
  TABULAR = "2",
  SERIES_TREE = "3",
}

export interface SRPSeriesTreeNode extends TreeTableNode<SRPSeriesTreeNode> {
  minDiameter?: number;
  maxDiameter?: number;
  minImperialDiameter?: number;
  maxImperialDiameter?: number;
  isImperialConverted?: boolean;
  name: string;
  count: number;
  parentCategoryCode: string;
  categoryCode: string;
  isSeries: boolean;
}

export interface TabularViewData {
  id: number;
  weight: string;
  weightImperial: string;
  product: ProductData;
  variantProducts: ProductData[];

  techValues: {
    [techValueUID: string]: {
      value: string;
      abbreviation: string;
      abbreviationAddition: string;
      isConverted: boolean;
    };
  };
}

export enum SortDirection {
  ASC = "-asc",
  DESC = "-desc",
}

export type SortOption = {
  code: string;
  isAscdesc?: boolean;
  name: string | undefined;
  showSortingArrow: boolean;
  sortingDirection?: SortDirection;
};
